import {
    CONDITIONS_OPTIONS,
    JIT_SUPPORTED_PROTOCOLS,
    PRIVILEGED_DEFAULT_SERVICES,
    PRIVILEGE_ACCOUNTS_ALL_SERVICES
} from '@silverfort-nodelibs/common/utils/consts';
import { EmptyState, EmptyStateIcons } from '@silverfort/sf-components';
import { ProtocolsSelector } from '../Resources/protocolsSelector';
import NamingConventionList from './NamingCoventionsList';
import { SCOPE_SHOW_SERVICES, DEFAULT_PROTOCOLS_AD } from '../TierConsts';
import { useMemo } from 'react';

const NamingConventions = ({ conventions, setConventions, selectedConvention, setSelectedConvention, scope, setShouldDisableSave }) => {
    const onNamingConventionChange = (newVal, index) => {
        const tempConventions = [...conventions];
        const current = tempConventions[index] || {};
        const next = { ...current, ...newVal };
        if (newVal.protocols && newVal.protocols.length === 0) {
            setShouldDisableSave(true);
        } else {
            setShouldDisableSave(false);
        }
        if (newVal.protocols && !newVal.protocols.includes(JIT_SUPPORTED_PROTOCOLS.KERBEROS)) {
            next.services = [];
        } else if (newVal.protocols && (!next.services || next.services.length === 0)) {
            next.services = [...PRIVILEGED_DEFAULT_SERVICES];
        }
        if (newVal.services && newVal.services.length === 0 && next.protocols?.includes(JIT_SUPPORTED_PROTOCOLS.KERBEROS)) {
            next.protocols = next.protocols.filter((p) => p !== JIT_SUPPORTED_PROTOCOLS.KERBEROS);
        }
        tempConventions[index] = next;
        setConventions(tempConventions);
    };

    const onConventionDelete = (index) => {
        const tempConventions = [...conventions];
        tempConventions.splice(index, 1);
        setConventions(tempConventions);
        setSelectedConvention(0);
    };

    const onAddConvention = () => {
        const tempConventions = [
            ...conventions,
            {
                conditionType: CONDITIONS_OPTIONS.START_WITH.value,
                conditionString: '',
                protocols: SCOPE_SHOW_SERVICES[scope] ? DEFAULT_PROTOCOLS_AD : [],
                services: SCOPE_SHOW_SERVICES[scope] ? [...PRIVILEGED_DEFAULT_SERVICES] : [PRIVILEGE_ACCOUNTS_ALL_SERVICES]
            }
        ];
        setConventions(tempConventions);
        setSelectedConvention(tempConventions.length - 1);
    };

    const onClearAll = () => {
        setConventions([]);
    };

    const { selectedConventionData, selectedProtocols, selectedServices } = useMemo(() => {
        const selectedConventionData = conventions[selectedConvention];
        const selectedProtocols = selectedConventionData?.protocols ?? [];
        const hasKerberos = selectedProtocols.includes(JIT_SUPPORTED_PROTOCOLS.KERBEROS);
        const selectedServices = hasKerberos ? (selectedConventionData?.services ?? []) : [];

        return { selectedConventionData, selectedProtocols, selectedServices };
    }, [conventions, selectedConvention]);

    return (
        <div
            className={`h-full ${
                SCOPE_SHOW_SERVICES[scope] ? 'w-[680px]' : 'w-[360px]'
            } rounded-lg border border-sf-gray-100 flex flex-col`}>
            {conventions.length ? (
                <div className="flex flex-1 h-full w-full">
                    <div className={`${SCOPE_SHOW_SERVICES[scope] ? 'border-r' : ''} border-sf-gray-100 h-full w-full`}>
                        <NamingConventionList
                            conventions={conventions}
                            selectedConvention={selectedConvention}
                            selectConvention={(index) => setSelectedConvention(index)}
                            onNamingConventionChange={onNamingConventionChange}
                            onAddConvention={onAddConvention}
                            onConventionDelete={onConventionDelete}
                            onClearAll={onClearAll}
                            scope={scope}
                        />
                    </div>
                    {SCOPE_SHOW_SERVICES[scope] && selectedConventionData != null && (
                        <div className="w-[270px] min-w-[270px]">
                            <ProtocolsSelector
                                selectedProtocols={selectedProtocols}
                                onChangeProtocols={(protocols) => onNamingConventionChange({ protocols }, selectedConvention)}
                                selectedServices={selectedServices}
                                onChangeServices={(services) => onNamingConventionChange({ services }, selectedConvention)}
                                defaultServices={PRIVILEGED_DEFAULT_SERVICES}
                                defaultProtocols={DEFAULT_PROTOCOLS_AD}
                                hideOptions={false}
                            />
                        </div>
                    )}
                </div>
            ) : (
                <div className="flex flex-1 h-full w-full items-center align-center justify-center">
                    <EmptyState
                        title="No Naming Conventions"
                        description="Add naming conventions by clicking Add Naming Convention button"
                        icon={EmptyStateIcons.NoItems}
                        actionText="Add Naming Convention"
                        onActionClick={onAddConvention}
                    />
                </div>
            )}
        </div>
    );
};

export default NamingConventions;
